"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetupChangePasswordPage = exports.SetupChangePasswordPageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var modal_layout_1 = require("../../elements/modal-layout");
var use_active_user_1 = require("../../../hooks/use-active-user");
var global_style_1 = require("../../elements/global-style");
var change_password_dialog_1 = require("../../elements/change-password-dialog");
var loading_layout_1 = require("../../elements/loading-layout");
exports.SetupChangePasswordPageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ModalLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ChangePasswordDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ModalLayout: (0, styled_components_1.default)(modal_layout_1.ModalLayout)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ModalLayoutStyles),
  ChangePasswordDialog: (0, styled_components_1.default)(change_password_dialog_1.ChangePasswordDialog)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ChangePasswordDialogStyles)
};
var SetupChangePasswordPage = function (props) {
  var className = props.className;
  var loading = (0, use_active_user_1.useActiveUser)().loading;
  // todo, perhaps add an error condition if the user is not found?? (this maybe cannot happen though)
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(global_style_1.GlobalStyle, null), loading ? react_1.default.createElement(loading_layout_1.LoadingLayout, null) : react_1.default.createElement(My.ModalLayout, null, react_1.default.createElement(My.ChangePasswordDialog, null)));
};
exports.SetupChangePasswordPage = SetupChangePasswordPage;
exports.SetupChangePasswordPage.defaultProps = exports.SetupChangePasswordPageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;